import React from "react";
import { Link } from "react-router-dom";
import {
  Music2,
  Palette,
  Dices,
  Calculator,
  Navigation,
  Compass,
  GraduationCap,
  ChevronRight,
} from "lucide-react";
import Layout from "../components/Layout";
import { useLanguage } from "../i18n/LanguageContext";

const MODULES = [
  {
    to: "/metronome",
    key: "metronome",
    descKey: "metronomeDesc",
    Icon: Music2,
    accent: "cyan",
    testid: "module-metronome",
    level: 1,
  },
  {
    to: "/colors",
    key: "colors",
    descKey: "colorsDesc",
    Icon: Palette,
    accent: "orange",
    testid: "module-colors",
    level: 2,
  },
  {
    to: "/colors-numbers",
    key: "colorsNumbers",
    descKey: "colorsNumbersDesc",
    Icon: Dices,
    accent: "cyan",
    testid: "module-colors-numbers",
    level: 3,
  },
  {
    to: "/math",
    key: "math",
    descKey: "mathDesc",
    Icon: Calculator,
    accent: "orange",
    testid: "module-math",
    level: 4,
  },
  {
    to: "/arrows",
    key: "arrows",
    descKey: "arrowsDesc",
    Icon: Navigation,
    accent: "cyan",
    testid: "module-arrows",
    level: 5,
  },
  {
    to: "/arrows-diag",
    key: "arrowsDiag",
    descKey: "arrowsDiagDesc",
    Icon: Compass,
    accent: "orange",
    testid: "module-arrows-diag",
    level: 6,
  },
  {
    to: "/tutorial",
    key: "tutorial",
    descKey: "tutorialDesc",
    Icon: GraduationCap,
    accent: "cyan",
    testid: "module-tutorial",
    level: 0,
  },
];

export default function Home() {
  const { t } = useLanguage();
  return (
    <Layout>
      <div
        className="vls-home-bg"
        aria-hidden="true"
        style={{ backgroundImage: "url('/logo.png')" }}
      />
      <section className="vls-hero" data-testid="home-hero">
        <h1 className="vls-hero-title">
          <span className="vls-grad-cyan">VELOCITY</span>{" "}
          <span className="vls-grad-orange">LAB SYSTEM</span>
        </h1>
        <p className="vls-hero-tagline">{t("tagline")}</p>
        <p className="vls-hero-sub">{t("welcomeSubtitle")}</p>
      </section>

      <section className="vls-modules" data-testid="modules-grid">
        <h2 className="vls-section-title">{t("chooseModule")}</h2>
        <div className="vls-modules-grid">
          {MODULES.map(({ to, key, descKey, Icon, accent, testid, level }) => (
            <Link
              key={key}
              to={to}
              className={`vls-module-card vls-accent-${accent}`}
              data-testid={testid}
            >
              <div className="vls-module-level">{level === 0 ? "GUIDE" : `LV.${level}`}</div>
              <div className="vls-module-icon">
                <Icon size={40} strokeWidth={1.8} />
              </div>
              <div className="vls-module-body">
                <h3 className="vls-module-title">{t(key)}</h3>
                <p className="vls-module-desc">{t(descKey)}</p>
              </div>
              <div className="vls-module-cta">
                <span>{t("start")}</span>
                <ChevronRight size={18} />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
